import React from 'react';

const CafeSection = () => {
  return (
    <>
      <style jsx>{`
        .cafe-section {
          background: white;
          position: relative;
          overflow: hidden;
          min-height: 500px;
        }

        .cafe-content-wrapper {
          display: flex;
          align-items: stretch;
          min-height: 500px;
          position: relative;
        }

        .cafe-text-content {
          flex: 1;
          padding: 80px 0px;
          padding-left: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        .cafe-section .cafe-title {
          font-size: 3rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0 0 40px 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.1);
          animation: cafeFadeInLeft 0.8s ease-out;
        }

        .cafe-section .cafe-description {
          font-size: 1.3rem;
          color: #666;
          line-height: 1.8;
          margin: 0 0 50px 0;
          font-family: 'Arial', sans-serif;
          animation: cafeFadeInUp 0.8s ease-out 0.3s both;
        }

        .cafe-section .visit-button {
          background: #2196F3;
          color: white;
          border: none;
          border-radius: 15px;
          padding: 20px 50px;
          font-size: 1.8rem;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          max-width: fit-content;
          text-decoration: none;
          box-shadow: 0 8px 25px rgba(33, 150, 243, 0.3);
          animation: cafeFadeInUp 0.8s ease-out 0.6s both;
          position: relative;
          overflow: hidden;
        }

        .cafe-section .visit-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          animation: cafeButtonShine 3s ease-in-out infinite;
        }

        @keyframes cafeButtonShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .cafe-section .visit-button:hover {
          background: #1976D2;
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(33, 150, 243, 0.4);
        }

        .cafe-section .visit-button:focus {
          outline: 3px solid rgba(33, 150, 243, 0.5);
          outline-offset: 2px;
        }

        .cafe-image-content {
          flex: 1;
          background: url('/images/restaurant.png') center/cover no-repeat;
          position: relative;
          animation: cafeSlideInRight 0.8s ease-out 0.4s both;
        }

        .cafe-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }

        .cafe-floating-elements {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          pointer-events: none;
        }

        .cafe-coffee-steam {
          position: absolute;
          font-size: 2rem;
          animation: cafeSteamRise 4s ease-in-out infinite;
          opacity: 0.7;
        }

        .cafe-coffee-steam:nth-child(1) {
          top: 30%;
          left: 20%;
          animation-delay: 0s;
        }

        .cafe-coffee-steam:nth-child(2) {
          top: 50%;
          right: 30%;
          animation-delay: 2s;
        }

        .cafe-coffee-steam:nth-child(3) {
          bottom: 40%;
          left: 40%;
          animation-delay: 1s;
        }

        @keyframes cafeSteamRise {
          0%, 100% { 
            transform: translateY(0px) scale(1); 
            opacity: 0.7; 
          }
          50% { 
            transform: translateY(-20px) scale(1.2); 
            opacity: 1; 
          }
        }

        .cafe-cutlery {
          position: absolute;
          font-size: 1.8rem;
          animation: cafeCutleryTwinkle 3s ease-in-out infinite;
        }

        .cafe-cutlery:nth-child(4) {
          top: 25%;
          right: 15%;
          animation-delay: 0.5s;
        }

        .cafe-cutlery:nth-child(5) {
          bottom: 35%;
          right: 20%;
          animation-delay: 1.5s;
        }

        @keyframes cafeCutleryTwinkle {
          0%, 100% { 
            transform: scale(1) rotate(0deg); 
            opacity: 0.6; 
          }
          50% { 
            transform: scale(1.1) rotate(5deg); 
            opacity: 1; 
          }
        }

        @keyframes cafeSlideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes cafeFadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes cafeFadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes cafeSlideInRight {
          from {
            opacity: 0;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 1024px) {
          .cafe-content-wrapper {
            flex-direction: column;
            min-height: auto;
          }

          .cafe-text-content {
            clip-path: none;
            padding: 60px 40px;
          }

          .cafe-section .cafe-title {
            font-size: 2.5rem;
          }

          .cafe-section .cafe-description {
            font-size: 1.2rem;
          }

          .cafe-section .visit-button {
            font-size: 1.6rem;
            padding: 18px 45px;
          }

          .cafe-image-content {
            min-height: 400px;
          }
        }

        @media (max-width: 768px) {
          .cafe-text-content {
            padding: 40px 20px;
            text-align: center;
          }

          .cafe-section .cafe-title {
            font-size: 2rem;
          }

          .cafe-section .cafe-description {
            font-size: 1.1rem;
            margin-bottom: 40px;
          }

          .cafe-section .visit-button {
            font-size: 1.4rem;
            padding: 16px 40px;
            margin: 0 auto;
          }

          .cafe-image-content {
            min-height: 300px;
          }

          .cafe-coffee-steam {
            font-size: 1.5rem;
          }

          .cafe-cutlery {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .cafe-text-content {
            padding: 30px 15px;
          }

          .cafe-section .cafe-title {
            font-size: 1.6rem;
          }

          .cafe-section .cafe-description {
            font-size: 1rem;
          }

          .cafe-section .visit-button {
            font-size: 1.2rem;
            padding: 14px 35px;
            width: 100%;
            max-width: 280px;
            text-align: center;
          }

          .cafe-image-content {
            min-height: 250px;
          }

          .cafe-coffee-steam {
            font-size: 1.3rem;
          }

          .cafe-cutlery {
            font-size: 1.3rem;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="cafe-section"
        role="region"
        aria-labelledby="cafe-heading"
        itemScope
        itemType="https://schema.org/Restaurant"
      >
        <div className="cafe-content-wrapper">
          <div className="cafe-text-content">
            <h2 
              id="cafe-heading"
              className="cafe-title"
              itemProp="name"
            >
              Café-Resto « L'ATELIER »
            </h2>

            <p className="cafe-description" itemProp="description">
              Un café-restaurant chaleureux où nos clients<br />
              peuvent se détendre, travailler ou savourer des<br />
              repas variés
            </p>

            <a 
              href="#visiter-cafe-atelier" 
              className="visit-button"
              role="button"
              aria-label="Visiter le café-restaurant L'Atelier"
              itemProp="url"
            >
              Visiter
            </a>
          </div>

          <div 
            className="cafe-image-content"
            role="img"
            aria-label="Intérieur du café-restaurant L'Atelier"
            itemProp="image"
          >
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Restaurant",
              "name": "Café-Resto L'Atelier",
              "description": "Un café-restaurant chaleureux où nos clients peuvent se détendre, travailler ou savourer des repas variés",
              "url": "https://faucon-bleu.ma",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Casablanca",
                "addressCountry": "MA"
              },
              "servesCuisine": "Cuisine variée",
              "priceRange": "$$",
              "amenityFeature": [
                {
                  "@type": "LocationFeatureSpecification",
                  "name": "Wi-Fi",
                  "value": true
                },
                {
                  "@type": "LocationFeatureSpecification",
                  "name": "Espace de travail",
                  "value": true
                }
              ],
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services du café-restaurant",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Restauration",
                      "description": "Repas variés dans un cadre chaleureux"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Espace détente",
                      "description": "Lieu pour se détendre et se relaxer"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Espace de travail",
                      "description": "Environnement propice au travail"
                    }
                  }
                ]
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default CafeSection;